import FormField from 'components/FormField';
import queryKeys from 'config/queryKeys';
import React from 'react';
import { useQuery } from 'react-query';
import { Objective, Plan } from 'types';

import * as remoteApi from 'api/remote';
import { ValueType } from 'react-select';
import { CustomTermKey, translate } from 'utils/customTermUtils';
import { shallowEqual, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import KoalaSelect, { KoalaSelectOption } from 'koala/components/Select';

interface Props {
  plan: Plan | undefined;
  objectiveId: string | undefined;
  setObjectiveId: (e: string) => void;
}

function ObjectivesList(props: Props) {
  const { plan, objectiveId, setObjectiveId } = props;
  const currentWorkspace = useSelector((state: any) => state.session.currentWorkspace, shallowEqual);
  const { t } = useTranslation();
  const handleSelection = (selected: ValueType<KoalaSelectOption, boolean>) => {
    const selectedObjective = selected as KoalaSelectOption;
    if (selectedObjective) {
      setObjectiveId(selectedObjective.value as string);
    }
  };
  // Get the objectives
  const staleTime = 0;
  const { data: objectivesResponse } = useQuery([queryKeys.objectives, plan?.id], remoteApi.fetchPlanObjectives, {
    staleTime,
  });

  const filteredObjectives: Objective[] = objectivesResponse ? objectivesResponse.data : [];

  // format objectives
  let objectives = filteredObjectives.map((objective: Objective) => {
    return {
      label: objective.title,
      value: objective.id,
    };
  });

  let selectedObjective = null;

  if (objectiveId) {
    selectedObjective = objectives.find((objective) => objective.value === objectiveId);
  }

  return (
    <FormField>
      <label>{translate(currentWorkspace, CustomTermKey.OBJECTIVE, 1)}</label>
      {objectives.length === 0 && (
        <div>
          {t('modals.moveOutcome.noPlan', {
            label: translate(currentWorkspace, CustomTermKey.OBJECTIVE, 2).toLowerCase(),
          })}
        </div>
      )}
      {objectives.length > 0 && (
        <KoalaSelect
          options={objectives}
          handleChange={(option) => handleSelection(option)}
          selectedOption={selectedObjective}
          placeholder={t('modals.moveOutcome.searchObjective', {
            label: translate(currentWorkspace, CustomTermKey.OBJECTIVE, 2),
          })}
          getOptionValue={(option: any) => option.value}
          labelFormat={(option: any) => option.label}
        />
      )}
    </FormField>
  );
}

export default ObjectivesList;
